{
    "language": { "khmer": "km", "english": "en" },
    "region": { "khmer": "KH", "english": "US" },
    "khmer": { "khmer": "ខ្មែរ", "english": "Khmer" },
    "english": { "khmer": "អង់គ្លេស", "english": "English" },

    "title": {
        "khmer": "គម្ពីរព្រះត្រៃបិដក",
        "english": "Bedok AI"
    },
    "title0": {
        "khmer": "គម្ពីរព្រះត្រៃបិដក <span class='arial font-black'>AI</span>",
        "english": "Bedok AI"
    },
    "title2": {
        "khmer": "គម្ពីរព្រះត្រៃបិដក",
        "english": "Bedok AI"
    },
    "title2o": {
        "khmer": "គម្ពីរព្រះត្រៃបិដក AI",
        "english": "Bedok AI"
    },
    "book": { "khmer": "ភាគទី​", "english": "Volume" },
    "baskets": {
        "khmer": [
            "ព្រះវិន័យ មាន ១៣ ភាគ",
            "ព្រះសុត្តន្ត មាន ៦៤ ភាគ",
            "ព្រះអភិធម្ម មាន ៣៣ ភាគ"
        ],
        "english": ["Vinaya Pitaka", "Suttanta Pitaka", "Abhidhamma Pitaka"],
        "colors": ["basket1", "basket2", "basket3"],
        "colors2": ["fill-yellow-400", "fill-orange-400", "fill-red-700"]
    },
    "baskets2": {
        "khmer": ["ព្រះវិន័យ ភាគទី", "ព្រះសុត្តន្ត ភាគទី", "ព្រះអភិធម្ម ភាគទី"],
        "english": ["Vinaya", "Suttanta", "Abhidhamma"]
    },
    "baskets3": {
        "khmer": [
            "ព្រះវិន័យ បិដក ភាគទី",
            "ព្រះសុត្តន្ត បិដក ភាគទី",
            "ព្រះអភិធម្ម បិដក ភាគទី"
        ],
        "english": [
            "Bedok Vinaya Volume",
            "Bedok Suttanta Volume",
            "Bedok Abhidhamma Volume"
        ]
    },
    "commentariesKhmer": {
        "khmer": "ព្រះអដ្ឋកថា​​ ខ្មែរ",
        "english": "Commentaries (Khmer)"
    },
    "commentariesPali": {
        "khmer": "ព្រះអដ្ឋកថា​ បាលី",
        "english": "Commentaries (Pali)"
    },

    "notifications": {
        "khmer": "ការជូនដំណឹង",
        "english": "Notifications"
    },
    "notifications1": {
        "khmer": "សូមបន្ថែមកម្មវិធីនេះទៅកាន់អេក្រង់ដើម (Home Screen) របស់អ្នក និងអនុញ្ញាតការជូនដំណឹង (Push Notifications) ដើម្បីទទួលបានការរំលឹកអំពីថ្ងៃសីល និងបុណ្យទានផ្សេងៗ!",
        "khmer2": "សូមដំឡើងកម្មវិធីនេះលើអេក្រង់ដើម និងបើកការជូនដំណឹង ដើម្បីទទួលបានព័ត៌មានរំលឹកអំពីពិធីបុណ្យសាសនាផ្សេងៗ។",
        "english": "Please add this app to your Home Screen and allow Push Notifications to receive reminders of Buddhist holidays!"
    },
    "notifications2": {
        "khmer": "តើអ្នកចង់ទទួលបានការរំលឹកអំពីថ្ងៃសីល និងបុណ្យទានផ្សេងៗដែរឬទេ?",
        "english": "Would you like to receive reminders of Buddhist holidays?"
    },
    "notifications3": {
        "khmer": "អ្នកនឹងទទួលបានការរំលឹកអំពីថ្ងៃសីល និងបុណ្យទានផ្សេងៗចាប់ពីពេលនេះតទៅ!",
        "khmer2": "ការរំលឹកអំពីថ្ងៃសីលត្រូវបានបើកជោគជ័យ!",
        "english": "You will now receive reminders of Buddhist holidays!"
    },

    "hero": {
        "khmer": "ព្រះត្រៃបិដក បាលី ប្រែជាភាសាខ្មែរ",
        "english": "Bedok AI from Pali to Khmer"
    },
    "hero0": {
        "khmer": "ព្រះត្រៃបិដក <span class='arial font-black'>AI</span> បាលី ប្រែជាភាសាខ្មែរ",
        "english": "Bedok AI from Pali to Khmer"
    },
    "subtitle": {
        "khmer": "ភាគ ១ ដល់ភាគ ១១០",
        "english": "Complete Collection"
    },
    "hero2": {
        "khmer": "ព្រះត្រៃបិដក បាលី ប្រែជាភាសាខ្មែរ: ភាគ ១ ដល់ភាគ ១១០",
        "english": "Bedok AI from Pali to Khmer: Complete Collection"
    },
    "hero2o": {
        "khmer": "ព្រះត្រៃបិដក AI បាលី ប្រែជាភាសាខ្មែរ: ភាគ ១ ដល់ភាគ ១១០",
        "english": "Bedok AI from Pali to Khmer: Complete Collection"
    },
    "movie": {
        "khmer": "សូមចុចនៅទីនេះដើម្បីមើលវីដេអូ រឿងព្រះពុទ្ធ",
        "english": "Tap Here to Watch Movie about Buddha"
    },

    "youtube": {
        "khmer": "ការណែនាំប្រើប្រាសតាមរយៈវិដេអូ",
        "english": "Instruction Videos"
    },
    "ai": {
        "khmer": "តម្លើងព្រះពុទ្ធ <span class='arial font-black'>AI</span>",
        "english": "Install Buddha AI"
    },
    "sw": {
        "khmer": "ដំឡើង <span class='arial font-black'>Silicon Wat</span>",
        "english": "Install Silicon Wat"
    },
    "tuktuk": { "khmer": "តុកតុក 333", "english": "333 Tuk Tuk" },
    "soon": {
        "khmer": "នឹងចេញឲ្យប្រើប្រាស់ឆាប់ៗ",
        "english": "Coming soon..."
    },
    "download": {
        "khmer": "ទាញយកភាគទាំងមូលនេះដើម្បីអានក្រៅបណ្តាញ",
        "english": "Download this entire volume to read offline"
    },
    "join": {
        "khmer": "ក្រុម​ប្រឹក្សា​ភិបាល​ <span class='arial font-black'>AI</span>",
        "english": "AI Buddhist Council"
    },

    "toc": {
        "khmer": "ព្រះពុទ្ធ <span class='arial font-black'>AI</span>",
        "english": "Buddha AI"
    },
    "ama": {
        "khmer": "សូមសួរខ្ញុំនូវអ្វីក៏បាន\nពេលប្រអប់មួយបើកឡើង​\nសូម​ចម្លងដាក់​ រួចចុចបញ្ជូន",
        "english": "Ask me anything\n\nNote: Paste this prompt into Gemini AI"
    },
    "paste": {
        "khmer": "តើអ្នកចង់បិទភ្ជាប់វាដែរឬទេ?",
        "english": "Would you like to paste?"
    },
    "trash": {
        "khmer": "តើអ្នកចង់លុបវាដែរឬទេ?",
        "english": "Would you like to delete?"
    },

    "qrcode": {
        "khmer": "ចុចលើវីដេអូខាងលើដើម្បីមើលកូដ QR សម្រាប់ចែករំលែកលើបណ្ដាញសង្គម។",
        "english": "👆 Tap on the video above to see the QR Code for sharing on social media."
    },
    "scan": {
        "khmer": "ប្រើកាមេរ៉ាទូរស័ព្ទថតកូដដើម្បីទាញយកគម្ពីរព្រះត្រៃបិដកមើល",
        "english": "Share this Bedok AI with others by telling them to scan this QR Code using their phone camera."
    },
    "gift": {
        "khmer": "ទាន​ដ៏​ប្រសើរ​ គឺ​ធម្មទាន",
        "english": "The Greatest Gift is the Gift of Dharma."
    },
    "copy": {
        "khmer": "ចុចលើកូដដើម្បីចម្លងការប្រើប្រាសផ្សព្វផ្សាយតាមណ្តាញសង្គម",
        "english": "Tap on the QR Code to copy the link to share on social media."
    },
    "copied": {
        "khmer": "ការថតចម្លងបានថតរួចរាល់",
        "english": "The link to this Bedok AI has been copied!"
    },
    "copied2": {
        "khmer": "អត្ថបទទាំងមូលត្រូវបានចម្លងហើយ!",
        "english": "The entire text has been copied!"
    },
    "copied3": {
        "khmer": "សំណេររបស់អ្នកត្រូវបានចម្លងទុកហើយ!",
        "english": "Your prompt has been copied!"
    },

    "page": { "khmer": "ទំព័រ", "english": "Page" },
    "total": { "khmer": "សរុប", "english": "Total" },
    "previous": { "khmer": "ទំព័រមុន", "english": "Previous Page" },
    "next": { "khmer": "ទំព័របន្ទាប់", "english": "Next Page" },

    "bookmark": {
        "khmer": "សញ្ញាសំគាល់ទំព័រអានហើយ",
        "english": "Bookmark Page"
    },
    "saved": {
        "khmer": "សញ្ញាសំគាល់ទំពរ័សៀវភៅបានអានរួច",
        "english": "This page has been bookmarked for this volume."
    },
    "removed": {
        "khmer": "សញ្ញាសំគាល់ទំពរ័សៀវភៅបានយកចេញ",
        "english": "The bookmark for this page has been removed."
    },

    "khmer2": {
        "khmer": "បិដកខ្មែរ <span class='arial'>AI</span>",
        "english": "Khmer Bedok AI"
    },
    "dict": { "khmer": "ជួន ណាត", "english": "Chuon Nath" },
    "map": { "khmer": "ចំនួន​អ្នក​អាន​", "english": "Readership" },
    "pali2": {
        "khmer": "បិដកបាលី <span class='arial'>AI</span>",
        "english": "Pali Bedok AI"
    },

    "read": { "khmer": "អានបិដក", "english": "Read Bedok" },
    "learn": {
        "khmer": "រៀនបិដក",
        "english": "Learn Bedok"
    },
    "share": {
        "khmer": "ចែករំលែក",
        "english": "Share"
    },

    "now": { "khmer": "ឥឡូវនេះ", "english": "Now" },
    "leaderboard": {
        "khmer": "អ្នកសកម្ម",
        "english": "Leaderboard"
    },
    "today": {
        "khmer": "ថ្ងៃនេះ",
        "english": "Today"
    },
    "history": {
        "khmer2": "គ្រប់ពេល",
        "english": "All Time",
        "khmer": "ថ្ងៃមុន",
        "english2": "History"
    },

    "speak": { "khmer": "និយាយ", "english": "Speak" },
    "stop": { "khmer": "ឈប់", "english": "Stop" },
    "tipitaka": { "khmer": "ត្រៃបិដក", "english": "Tipitaka" },
    "buddha": {
        "khmer": "បិដក <span class='arial'>AI</span>",
        "english": "Bedok AI"
    },

    "light": { "khmer": "ពន្លឺពេលថ្ងៃ", "english": "Light Mode" },
    "dark": { "khmer": "ពន្លឺពេលយប់", "english": "Dark Mode" },
    "auto": { "khmer": "ពន្លឺស្វ័យប្រវត្តិ", "english": "Auto Mode" },
    "automatic": {
        "khmer": "ពន្លឺនឹងផ្លាស់ប្តូរពេលយប់និងពេលថ្ងៃខ្លួនឯង",
        "english": "The color scheme will now adjust automatically."
    },

    "online": {
        "khmer": "អ្នកត្រូវបានភ្ជាប់ទៅអ៊ីនធឺណិតហើយ",
        "english": "You're back online!"
    },
    "offline": {
        "khmer": "អ្នកមិនត្រូវបានភ្ជាប់ទៅអ៊ីនធឺណិតឡើយ",
        "english": "Please connect to the internet."
    },

    "refresh": {
        "khmer": "សូមទាញយកកម្មវិធី​ថ្មី",
        "english": "A new version is available. Refresh to update?"
    },
    "updated": {
        "khmer": "កម្មវិធីថ្មី ធ្វើនៅថ្ងៃទី​​",
        "english": "Last updated on"
    },

    "donate": {
        "khmer": "ប្រើ HeartBank<sup class='mr-1'>®</sup> សំរាប់អរគុណ",
        "english": "Thank with HeartBank<sup>®</sup>",
        "khmer2": "បរិច្ចាគ",
        "english2": "Donate"
    },
    "donate1": {
        "khmer": "កាតឥណទាន",
        "khmer2": "អរគុណកាត",
        "english": "Thank with Card"
    },
    "donate2": {
        "khmer": "ប្រាក់សុទ្ធ",
        "khmer2": "អរគុណប្រាក់",
        "english": "Thank with Cash"
    },
    "donateNow": {
        "khmer": "បរិច្ចាគឥឡូវនេះ",
        "english": "Donate Now"
    },
    "donateTitle": {
        "khmer": "ការបរិច្ចាគគាំទ្រគំរោងបង្កើតព្រះត្រៃបិដកអេអាយ",
        "english": "Support the Development of Bedok AI"
    },
    "donateBody": {
        "khmer": "<p>យើងខ្ញុំសូមអំពាវនាវដល់សប្បុរសជនគ្រប់លំដាប់ថ្នាក់ មេត្តាជួយគាំទ្រគំរោងព្រះត្រៃបិដកអេអាយអនឡាញឲ្យមានគុណភាព និងប្រសិទ្ធិភាពខ្ពស់ ដោយផ្តល់នូវការបរិច្ចាគឧបត្ថម្ភ ដល់ក្រុមយើងខ្ញុំតាមកម្លាំង និងសទ្ធា។</p><p>ការបរិច្ចាគឧបត្ថម្ភរបស់អ្នក គឺជាការជួយធ្វើឲ្យផ្នែកព្រះពុទ្ធសាសនាមានការផ្សព្វផ្សាយទូលំទូលាយ ទៅដល់ពុទ្ធសាសនិកនៅក្នុងព្រះរាជាណាចក្រកម្ពុជា និងបរទេស ។ មិនត្រឹមប៉ុណ្ណោះទេ ថែមទាំងជួយការអភិវឌ្ឍន៍តាមបណ្តាញ​អេអាយ​អ​នឡានឲ្យល្អប្រសើរ និងជួយឲ្យក្រុមយើងខ្ញុំ មានកម្លាំចិត្ត និងលទ្ធភាពអាចទិញឧបករណ៍បច្ចេកវិទ្យាអេឡិចត្រូនិចផ្សេងៗ ដើម្បីយកមកប្រើប្រាសក្នុងគំរោង​​ឲ្យ​កាន់តែល្អ​​ទំនើប​និង​ទាន់​សម័យជាង​មុន​។</p><p>ការចូលរួមបរិច្ចាគរបស់អ្នក គឺជាធម្មទានដ៏ល្អបំផុត និងជាទានឈ្នះអស់ទានទាំងពួង ព្រោះការចូលរួមរបស់អ្នក​ជាការចែករំលែកព្រះធម៌ដែលព្រះសម្មាសម្ពុទ្ធបានសម្តែង ដល់អ្នកកំពុងចង់ដឹង ចង់ចេះ និងចង់យល់ពីធម៌។</p><p>ក្រុមយើងខ្ញុំ សូមថ្លែងអំណរគុណដ៏ជ្រាលជ្រៅបំផុត ដល់ការចូលរួមចំណែក ក្នុងការធ្វើឲ្យគំរោងអេអាយអនឡាញនេះ ទទួលបានជោគជ័យ។</p>",
        "english": "<p>We sincerely appeal to all generous individuals to support our online AI Tipitaka project in improving its quality and effectiveness by providing donations to our team according to your means and faith.</p><p>Your contributions will not only help enhance the development of our online platform but also empower our team with the resources and ability to acquire advanced technological equipment to implement and operate the project more effectively and in line with modern digital AI advancements.</p><p>Your participation in this donation is the most virtuous act of giving and the ultimate form of generosity, as it reflects the sharing of the Dhamma that the Buddha has taught to those seeking knowledge and understanding of the truth.</p><p>Our team would like to express our deepest gratitude for your participation in making this online AI project a success.</p>",
        "english2": "<p>We invite kind-hearted individuals like you to make a meaningful impact by supporting our mission to enhance the <strong>Online Tripeitaka Project</strong>. Your generosity will directly contribute to improving the quality and effectiveness of this important initiative.</p><h2>Why Your Support Matters:</h2><p><strong>Empowering Progress:</strong> Your donation enables us to invest in advanced technology and tools, ensuring the project operates smoothly and stays up-to-date in today’s digital world.</p><p><strong>Inspiring Impact:</strong> Your contribution fuels our team’s dedication to preserving and modernizing this invaluable resource for everyone.</p><p>No matter the size, every donation counts. Together, we can make a difference in elevating this project to new heights. Join us in this meaningful journey by donating today and being a part of something truly impactful.</p><p>Thank you in advanxe for your kindness and support!</p>"
    },

    "speak2": { "khmer": "អានជាសំឡេង", "english": "Read Aloud" },
    "stop2": { "khmer": "បញ្ឈប់អាន", "english": "Stop Reading" },

    "tutor": {
        "khmer": "គ្រូ <span class='arial'>AI</span>",
        "english": "AI Tutor"
    },
    "tutor2": {
        "khmer": "ប្រសាសន៍របស់គ្រូបានចម្លងរួចហើយ!",
        "english": "The tutor prompt has been copied!"
    },
    "tutor3": {
        "khmer": "សូមពន្យល់អំពីទំព័រខាងក្រោមពីព្រះត្រៃបិដកជាទ្រង់ទ្រាយជាវាក្យៗជាបន្តបន្ទាប់ជាភាសាខ្មែរ។: \n\n",
        "english": "Translate and explain the following page from the Tipitaka line by line in English: \n\n"
    },
    "tutor4": {
        "khmer": "ប្រសាសន៍របស់គ្រូបានចម្លងរួចហើយ!",
        "english": "Detailed analysis in English: "
    },

    "quiz": {
        "khmer": "សិស្ស <span class='arial'>AI</span>",
        "english": "AI Quiz"
    },
    "quiz2": {
        "khmer": "ប្រធានបទសំណួរត្រូវបានចម្លងរួចហើយ!",
        "english": "The quiz prompt has been copied!"
    },
    "quiz3": {
        "khmer": "បង្កើតល្បែងសំណួរពិតឬមិនពិតជាភាសាខ្មែរ ជាល្បែងសម្ដែងទៅវិញទៅមករវាងអ្នកនិងខ្ញុំ សម្រាប់ទំព័រខាងក្រោមពីព្រះត្រៃបិដក។: \n\n",
        "english": "Create a true or false quiz in English as a back and forth game between you and me for the following page from the Tipitaka: \n\n"
    },

    "pali3": { "khmer": "ថតចម្លងពាក្យបាលី", "english": "Pali Transcription" },
    "khmer3": {
        "khmer": "ថតចម្លងពាក្យខ្មែរ",
        "english": "Khmer Transcription"
    },
    "copyall": { "khmer": "ថតចម្លង", "english": "Copy Text" },
    "open": { "khmer": "បើក", "english": "Open" },
    "close": { "khmer": "បិទ", "english": "Close" },
    "clear": { "khmer": "សម្អាត", "english": "Clear" },
    "copyError": {
        "khmer": "សូមអភ័យទោស គ្មានអ្វីត្រូវចម្លងទេ",
        "english": "Sorry, there is nothing to copy."
    },
    "cover": {
        "khmer": "ទំព័រគម្រប",
        "english": "Cover Page"
    },
    "shareError": {
        "khmer": "សូមអភ័យទោស សូមព្យាយាមម្តងទៀត",
        "english": "Sorry, please try again."
    },

    "dict2": {
        "khmer": "វចនានុក្រម សម្តេច ជូន ណាត",
        "english": "Chuon Nath Dictionary"
    },
    "dict3": {
        "khmer": "វចនានុក្រម​",
        "english": "Dictionary"
    },
    "search": { "khmer": "ស្វែងរក", "english": "Search" },
    "search2": {
        "khmer": "បញ្ចូលពាក្យដើម្បីរកនិយមន័យ",
        "english": "Enter word to look up the definition."
    },
    "search3": {
        "khmer": "មិនមានលទ្ធផលទេ",
        "english": "There are no suggestions."
    },
    "search4": {
        "khmer": "មិនមាននិយមន័យសម្រាប់ពាក្យនោះទេ",
        "english": "There is no definition for that word."
    },
    "back": { "khmer": "ពាក្យមុន", "english": "Go Back" },
    "loading": { "khmer": "កំពុងផ្ទុក...", "english": "Loading..." },

    "transcribe1": {
        "khmer": "ឥតមានពាក្យអ្វីត្រូវថតចម្លងទេ",
        "english": "There's no text in the image."
    },
    "transcribe2": {
        "khmer": "មានបញ្ហាបច្ចកទេសក្នុងការថតចម្ល",
        "english": "Sorry, there was an error transcribing."
    },
    "transcribe3": {
        "khmer": "រកពាក្យថតចម្លងមិនឃើញ",
        "english": "No text was found."
    },
    "transcribe4": {
        "khmer": "កំពុងដំណើរការ",
        "english": "Transcribing in progress"
    },

    "feedback": {
        "khmer": "ផ្តល់មតិយោបល់",
        "english": "Give Feedback"
    },
    "feedback1": {
        "khmer": "តើអ្នកចូលចិត្តកម្មវិធីនេះឬទេ?",
        "english": "Do you like this app?"
    },
    "feedback2": {
        "khmer": "តើយើងអាចធ្វើឱ្យកម្មវិធីនេះប្រសើរឡើងសម្រាប់អ្នកដូចម្តេចបានខ្លះ?",
        "english": "How can we improve this app for you?"
    },
    "feedback3": {
        "khmer": "បញ្ចូលគណនី",
        "english": "Login to Submit"
    },
    "feedback4": {
        "khmer": "បញ្ជូន​",
        "english": "Submit"
    },
    "feedback5": {
        "khmer": "ចាកចេញ​",
        "english": "Logout"
    },
    "feedback6": {
        "khmer": "ទទួលបានការបញ្ចុះតម្លៃនៅ 333 Tuk Tuk នៅពេលអ្នកបញ្ចប់ការផ្តល់មតិយោបល់!",
        "english": "Receive a discount at 333 Tuk Tuk when you complete a feedback!"
    },
    "feedback7": {
        "khmer": "សូមអនុញ្ញាតឲ្យបង្អួចលេចឡើង ដើម្បីចូលប្រើ HeartBank® Vault របស់អ្នក។",
        "english": "Please allow popup to access your HeartBank® Vault"
    },
    "feedback8": {
        "khmer": "សូមអរគុណចំពោះការផ្តល់មតិយោបល់របស់អ្នក!",
        "english": "Thanks so much for giving us a feedback!"
    },
    "feedback9": {
        "khmer": "សូមអរគុណចំពោះការផ្តល់មតិយោបល់របស់អ្នក! កូដបញ្ចុះតម្លៃសម្រាប់ 333 Tuk Tuk របស់អ្នកគឺ 333។",
        "english": "Thanks so much for giving us a feedback! Your 333 Tuk Tuk discount code is 333."
    },
    "feedback10": {
        "khmer": "ចូលដោយប្រើ HeartBank® ដើម្បីធ្វើសមកាលកម្មចំណាំរបស់អ្នកនៅលើឧបករណ៍របស់អ្នក។",
        "english": "Login with HeartBank® to sync your bookmarks across your devices."
    },
    "feedback11": {
        "khmer": "ចូលប្រើ",
        "english": "Login"
    },
    "feedback12": {
        "khmer": "អ្នកបានចេញពី Silicon Wat ដោយជោគជ័យហើយ។ តើអ្នកចង់ចេញពី HeartBank® Vault ផងដែរ​ឬទេ?",
        "english": "You have successfully logged out of Silicon Wat. Would you like to log out of HeartBank® Vault, too?"
    },
    "feedback13": {
        "khmer": "អ្នកបានចេញពី HeartBank® Vault និង Silicon Wat ដោយជោគជ័យហើយ។",
        "english": "You have successfully logged out of HeartBank® Vault and Silicon Wat."
    },
    "feedback14": {
        "khmer": "នៅពេលដែលអ្នកបានចូលប្រើ ប៊ុកម៉ាទាំងអស់របស់អ្នកនឹងត្រូវសម្របសម្រួលជាមួយឧបករណ៍ទាំងអស់របស់អ្នក។",
        "english": "When you're logged in, your bookmarks are synced across your devices."
    },
    "feedback15": {
        "khmer": "សួស្តី!",
        "english": "Hello!"
    },
    "feedback16": {
        "khmer": "សួស្តី, ",
        "english": "Hi, "
    },
    "feedback17": {
        "khmer": "អ្នកបានចូលប្រើប្រាស់ HeartBank® Vault និង Silicon Wat បានជោគជ័យ។",
        "english": "You have successfully logged into HeartBank® Vault and Silicon Wat."
    },

    "editor": {
        "khmer": "អ្នកនិពន្ធ",
        "english": "Editor"
    },
    "editor2": {
        "khmer": "គ្មាន",
        "english": "None"
    },
    "editor3": {
        "khmer": "ផ្សព្វផ្សាយ",
        "english": "Publish"
    },
    "editor4": {
        "khmer": "តើអ្នកចង់ផ្សាយផ្សំឬទេ?",
        "english": "Would you like to publish?"
    },
    "editor5": {
        "khmer": "សេចក្ដីព្រាងរបស់អ្នកត្រូវបានរក្សាទុកនៅលើឧបករណ៍នេះ។",
        "english": "Your draft has been saved on this device"
    },
    "editor6": {
        "khmer": "ការប្រែជាភាសាអង់គ្លេសត្រូវបានធ្វើបច្ចុប្បន្នភាពហើយ។",
        "english": "English translation has been updated"
    },
    "editor7": {
        "khmer": "បង្ហោះការអានអូឌីយ៉ូ",
        "english": "Upload Audio Reading"
    },
    "editor8": {
        "khmer": "ធ្វើបច្ចុប្បន្នភាពការបកប្រែភាសាអង់គ្លេស",
        "english": "Update English Translation"
    },

    "audio": {
        "khmer": "សូមជ្រើសរើសឯកសារ MP3 មួយ",
        "english": "Please select an MP3 file"
    },
    "audio2": {
        "khmer": "អាចប្រើបានតែឯកសារ MP3 មួយប៉ុណ្ណោះ",
        "english": "Only one MP3 file is allowed"
    },
    "audio3": {
        "khmer": "កំពុងផ្ទុកឡើង...",
        "english": "Uploading..."
    },
    "audio4": {
        "khmer": "ផ្ទុកឡើងដោយជោគជ័យ!",
        "english": "Upload successful!"
    },

    "map1": {
        "khmer": "តើអ្នកចង់ចែករំលែកទីតាំងរបស់អ្នក ដើម្បីមើលអ្នកអានផ្សេងទៀតឬទេ?",
        "english": "Would you like to share your location to see other readers?"
    },
    "map2": {
        "khmer": "សូមបើកមុខងារ geolocation ដើម្បីមើលអ្នកអានផ្សេងទៀត",
        "english": "Please enable geolocation to see other readers"
    },
    "map3": {
        "khmer": "ចាំបាច់ត្រូវការមុខងារ geolocation ដើម្បីមើលអ្នកអានផ្សេងទៀត។",
        "english": "Geolocation is required to see other readers"
    },
    "map4": {
        "khmer": "សូមអភ័យទោស សូមសាកល្បងម្ដងទៀតក្រោយមក។",
        "english": "Sorry, please try again later"
    },
    "map5": {
        "khmer": "ចូលគណនី",
        "english": "Login"
    },
    "map6": {
        "khmer": "333 ឡានក្រុង",
        "english": "Bus 333"
    },
    "map16": {
        "khmer": "ប្រវត្តិ​ខ្ញុំ",
        "english": "Profile"
    },
    "map7": {
        "khmer": "អ្នកអានព្រះត្រៃបិដក",
        "english": "Bedok Reader"
    },
    "map8": {
        "khmer": "អានបាន",
        "english": "Hours Read"
    },
    "map8b": {
        "khmer": "ម៉ោង",
        "english": ""
    },
    "map14": {
        "khmer": "អានបាន",
        "english": "Pages Read"
    },
    "map14b": {
        "khmer": "ទំព័រ",
        "english": ""
    },
    "map18": {
        "khmer": "ទស្សកិច្ចពុទ្ធារាម",
        "english": "Temple Visits"
    },
    "map18b": {
        "khmer": "ដង",
        "english": ""
    },
    "map9": {
        "khmer": "សរុបអ្នកអាន",
        "english": "Total Readers"
    },
    "map9b": {
        "khmer": "នាក់",
        "english": ""
    },
    "map42": {
        "khmer": "ព្រះសង្ឃសរុប",
        "english": "Total Monks"
    },
    "map42b": {
        "khmer": "នាក់",
        "english": ""
    },
    "map43": {
        "khmer": "ផ្ទះសរុប",
        "english": "Total Homes"
    },
    "map43b": {
        "khmer": "នាក់",
        "english": ""
    },
    "map44": {
        "khmer": "វត្តអារាមសរុប",
        "english": "Total Temples"
    },
    "map44b": {
        "khmer": "នាក់",
        "english": ""
    },
    "map10": {
        "khmer": "សរុប",
        "english": "Total Hours"
    },
    "map10b": {
        "khmer": "ម៉ោង",
        "english": ""
    },
    "map13": {
        "khmer": "សរុបបានអាន",
        "english": "Total Pages"
    },
    "map13b": {
        "khmer": "ទំព័រ",
        "english": ""
    },
    "map11": {
        "khmer": "សរុបពាក្យអរគុណ",
        "english": "Total Thanks"
    },
    "map11b": {
        "khmer": "នាក់",
        "english": ""
    },
    "map12": {
        "khmer": "ការបរិច្ចាគសរុប",
        "english": "Total Donations"
    },
    "map15": {
        "khmer": "wat",
        "english": "wat"
    },
    "map17": {
        "khmer": "កម្ពុជា",
        "english": "Cambodia"
    },
    "map17b": {
        "khmer": "កម្ពុជា",
        "english": "United States of America"
    },
    "map17c": {
        "khmer": "ប្រទេសបារាំង",
        "english": "France"
    },
    "map17d": {
        "khmer": "អូស្ត្រាលី",
        "english": "Australia"
    },
    "map19": {
        "khmer": "តើអ្នកប្រាកដថាចង់ចេញពី HeartBank® មែនទេ?",
        "english": "Are you sure you want to log out of HeartBank®?"
    },
    "map20": {
        "khmer": "ខ្ញុំ",
        "english": "My Profile"
    },
    "map21": {
        "khmer": "អ្នកទស្សនាដែលបានចុះឈ្មោះ",
        "english": "Checked-In Visitors"
    },
    "map22": {
        "khmer": "ការកំណត់",
        "english": "Settings"
    },
    "map23": {
        "khmer": "លេខសម្ងាត់",
        "english": "Passkeys"
    },
    "map24": {
        "khmer": "ចុះឈ្មោះចូល",
        "english": "Check-In"
    },
    "map25": {
        "khmer": "ក្លឹបសៀវភៅ",
        "english": "Book Club"
    },
    "map26": {
        "khmer": "អរគុណអ្នក",
        "english": "Thank Me"
    },
    "map27": {
        "khmer": "លំដាប់ថ្នាក់ទី ",
        "english": "Rank"
    },
    "map28": {
        "khmer": "សូមអានរង្វាន់លើកទឹកចិត្ត",
        "english": "Encouragement Reward"
    },
    "map28b": {
        "khmer": "សូម​អ្នក​បញ្ចូល​ QR Code / លេខគណនី នៃ​ធនាគារ​ ABA របស់​អ្នកនៅ​ទីនេះ​ ដេីម្បី​ងាយ​ស្រួលទទួលប្រាក់",
        "english": "What\\'s your ABA account number?"
    },
    "map29": {
        "khmer": "ជូនរង្វាន់លើកទឹកចិត្តអ្នក",
        "english": "Reward Me"
    },
    "map30": {
        "khmer": "បិទបើក និងបិទ",
        "english": "Toggle On and Off"
    },
    "map31": {
        "khmer": "ប្រើ HeartBank® សំរាប់អរគុណ",
        "english": "Thank with HeartBank®"
    },
    "map32": {
        "khmer": "ធ្វើទានតាមរយៈខ្ញុំ",
        "english": "The Gift of Giving"
    },
    "map32b": {
        "khmer": "សូម​អ្នក​បញ្ចូល​ QR Code / លេខគណនី នៃ​ធនាគារ​ ABA របស់​អ្នកនៅ​ទីនេះ​ ដេីម្បី​ងាយ​ស្រួលទទួលប្រាក់",
        "english": "What\\'s your ABA account number?"
    },
    "map33": {
        "khmer": "ធ្វើទានតាមរយៈអ្នក",
        "english": "Sponsor Me"
    },
    "map33b": {
        "khmer": "គោលបំណងរបស់ទាន",
        "english": "How should I donate on your behalf?"
    },
    "map34": {
        "khmer": "ពួកយើង​សូម​ថ្លែង​អំណរគុណ​ដល់​អ្នក​ ដែល​បាន​ព្យាយាម​ អាន​គម្ពីរ​ព្រះ​ត្រៃ​បិដក​ បាន​ ៥០​ ម៉ោង​ ក្នុង​ខែ​នេះ​។ ដូច្នេះពួកយើង ​សូម​ចូល​រួម​ជា​អំណោយ​លេីក​ទឹក​ចិត្ត​ចំនួន​ ៤០០០​ រៀល​ ដល់​ការ​អាន​ ដើម្បី​បង្កើន​ការ​យល់ដឹង​ក្នុង​ទ្រឹស្តី​របស់​ព្រះ​សម្មាសម្ពុទ្ធរបស់អ្នក។",
        "english": "We would like to express our gratitude to those who have read the Tipitaka (Bedok) for 60 hours this month. We would like to contribute 4,000 riels in monetary and spiritual contributions to the reading and increasing understanding of the Buddha."
    },
    "map35": {
        "khmer": "លុបកម្មវិធីអាន",
        "english": "Delete Reader"
    },
    "map35b": {
        "khmer": "តើអ្នកពិតជាចង់លុបកម្មវិធីអាននេះមែនទេ?",
        "english": "Are you sure you want to delete this reader?"
    },
    "map36": {
        "khmer": "សូមរង់ចាំ...",
        "english": "Please wait..."
    },
    "map37": {
        "khmer": "អ្នកបានលើសកូតាឥតគិតថ្លៃហើយ។ សូមរង់ចាំរហូតដល់ខែក្រោយ។",
        "english": "You have exceeded the free quota. Please wait until next month."
    },
    "map38": {
        "khmer": "បង្ហាញ ឬលាក់ប្រាសាទ",
        "english": "Show or hide temples"
    },
    "map39": {
        "khmer": "បង្ហាញ ឬលាក់ព្រះសង្ឃ",
        "english": "Show or hide monks"
    },
    "map40": {
        "khmer": "បង្ហាញ ឬលាក់ផ្ទះ",
        "english": "Show or hide homes"
    },
    "map41": {
        "khmer": "បង្ហាញ ឬលាក់អ្នកអាន",
        "english": "Show or hide readers"
    },
    "map45": {
        "khmer": "ប៉ះដើម្បីបើកទីតាំងនេះនៅក្នុង Google ផែនទី",
        "english": "Tap to open this location in Google Maps"
    },
    "map46": {
        "khmer": "តើ​វត្ត​ថ្មី​នេះ​មាន​ឈ្មោះ​អ្វី?",
        "english": "What's the new name for this temple?"
    },
    "map46b": {
        "khmer": "ចុចដើម្បីកែសម្រួលឈ្មោះវត្តនេះ",
        "english": "Tap to edit the name of this temple"
    },
    "map47": {
        "khmer": "តើអាសយដ្ឋានថ្មីសម្រាប់វត្តនេះជាអ្វី?",
        "english": "What's the new address for this temple?"
    },
    "map47b": {
        "khmer": "ចុចដើម្បីកែសម្រួលអាសយដ្ឋាននៃវត្តនេះ",
        "english": "Tap to edit the address of this temple"
    },
    "map48": {
        "khmer": "តើ​អ្វី​ទៅ​ជា​តំណ​ភ្ជាប់​ថ្មី​ទៅ​កាន់​វត្ត​នេះ?",
        "english": "What's the new link to this temple?"
    },
    "map48b": {
        "khmer": "ចុចដើម្បីកែសម្រួលតំណភ្ជាប់ទៅកាន់វត្តនេះ",
        "english": "Tap to edit the link to this temple"
    },
    "map49b": {
        "khmer": "បោះពុម្ពផ្សាយប្រាសាទ",
        "english": "Publish Temple"
    },
    "map49": {
        "khmer": "តើអ្នកពិតជាចង់បោះពុម្ពផ្សាយវត្តនេះមែនទេ?",
        "english": "Are you sure you want to publish this temple?"
    },
    "map50b": {
        "khmer": "ឈប់បោះពុម្ពផ្សាយប្រាសាទ",
        "english": "Unpublish Temple"
    },
    "map50": {
        "khmer": "តើអ្នកពិតជាចង់ឈប់បោះពុម្ពផ្សាយប្រាសាទនេះមែនទេ?",
        "english": "Are you sure you want to unpublish this temple?"
    },
    "map51b": {
        "khmer": "លុបប្រាសាទ",
        "english": "Delete Temple"
    },
    "map51": {
        "khmer": "តើអ្នកពិតជាចង់លុបវត្តនេះមែនទេ?",
        "english": "Are you sure you want to delete this temple?"
    },
    "map52": {
        "khmer": "តើវត្តនេះមានឈ្មោះអ្វី?",
        "english": "What's the name of this temple?"
    },
    "map53": {
        "khmer": "បន្ថែមប្រាសាទ",
        "english": "Add Temple"
    },
    "map54": {
        "khmer": "សូមអភ័យទោស ទីតាំងបច្ចុប្បន្នរបស់អ្នកមិនមានទេ",
        "english": "Sorry, your current location is not available"
    },
    "map55": {
        "khmer": "ប៉ះដើម្បីស្វែងរកទីក្រុង អ្នកអាន ព្រះសង្ឃ ផ្ទះ ឬប្រាសាទ",
        "english": "Tap to search for city, reader, monk, home, or temple"
    },
    "map56": {
        "khmer": "ចុចដើម្បីបន្ថែមប្រាសាទទៅទីតាំងបច្ចុប្បន្នរបស់អ្នក",
        "english": "Tap to add a temple to your current location"
    },
    "map57": {
        "khmer": "ចុចដើម្បីបន្ថែមផ្ទះទៅទីតាំងបច្ចុប្បន្នរបស់អ្នក",
        "english": "Tap to add a home to your current location"
    },
    "map58": {
        "khmer": "ប៉ះដើម្បីបើក ឬបិទសំឡេង",
        "english": "Tap to turn the sound on or off"
    },
    "map59": {
        "khmer": "តើ​កូអរដោនេ GPS របស់​វត្ត​នេះ​ស្ថិត​នៅ​ត្រង់​ណា?",
        "english": "What's the GPS coordinate of this temple?"
    },
    "map60": {
        "khmer": "ទុក​ឲ្យ​ទទេ​សម្រាប់​ទីតាំង​បច្ចុប្បន្ន​របស់​អ្នក",
        "english": "Leave blank for your current location"
    },

    "movie1": {
        "khmer": "ភាគ 1",
        "english": "Part 1"
    },
    "movie2": {
        "khmer": "ភាគ 2",
        "english": "Part 2"
    },
    "movie3": {
        "khmer": "ភាគ 3",
        "english": "Part 3"
    },
    "movie4": {
        "khmer": "ភាគ 4",
        "english": "Part 4"
    },
    "movie5": {
        "khmer": "ភាគ 5",
        "english": "Part 5"
    },
    "movie6": {
        "khmer": "រឿងព្រះពុទ្ធ",
        "english": "Buddha Movie"
    },
    "movie7": {
        "khmer": "ទាញយកភាពយន្តដើម្បីមើលក្រៅបណ្តាញ",
        "english": "Download movie to watch offline"
    },
    "movie8": {
        "khmer": "1 ចប់",
        "english": "Next"
    },
    "movie9": {
        "khmer": "1 ចប់",
        "english": "Part 1"
    },
    "movie10": {
        "khmer": "សូមអភ័យទោស ការទាញយកភាពយន្តបានបរាជ័យ។ សូមលុបវាចោល ហើយព្យាយាមម្តងទៀត។",
        "english": "Sorry, movie download failed. Please delete and try again."
    },
    "movie11": {
        "khmer": "ផ្អាកការទាញយកភាពយន្ត",
        "english": "Pause movie download"
    },
    "movie12": {
        "khmer": "លុបភាពយន្តចេញពីឧបករណ៍របស់អ្នក",
        "english": "Delete movie from your device"
    },
    "movie13": {
        "khmer": "តើអ្នកប្រាកដថាចង់លុបភាពយន្តនេះចេញពីឧបករណ៍របស់អ្នកមែនទេ?",
        "english": "Are you sure you want to delete this movie from your device?"
    },
    "movie14": {
        "khmer": "ទាញយកភាពយន្តបន្ត",
        "english": "Resume movie download"
    },
    "movie15": {
        "khmer": "✅ ភាពយន្តរបស់អ្នកត្រូវបានទាញយកដោយជោគជ័យទៅក្នុងឧបករណ៍របស់អ្នក។ ឥឡូវនេះអ្នកអាចមើលវាបានពេលគ្មានអ៊ីនធឺណិត។",
        "english": "✅ Your movie has successfully downloaded to your device. You can now watch it while offline."
    },
    "movie16": {
        "khmer": "អ្នកបានលើសចំនួនកំណត់ឥតគិតថ្លៃរបស់អ្នក។ សូមព្យាយាមម្តងទៀតនៅថ្ងៃស្អែក។",
        "english": "You have exceeded your free quota. Please try again tomorrow."
    },
    "movie17": {
        "khmer": "ប៉ះវីដេអូដើម្បីចាក់",
        "english": "Tap video to play"
    },

    "code": {
        "khmer": "តំណភ្ជាប់ភ្នាក់ងាររបស់អ្នកត្រូវបានចម្លងទៅក្ដារតម្បៀតខ្ទាស់របស់អ្នកហើយ!",
        "english": "Your Agent Link has been copied to your clipboard!"
    },
    "code2": {
        "khmer": "ចុចដើម្បីចម្លងតំណភ្ជាប់ភ្នាក់ងាររបស់អ្នក ដើម្បីចែករំលែក",
        "english": "Tap to copy your HeartBank® Agent Link to share"
    },

    "chatgpt": {
        "khmer": "Chat GPT",
        "english": "Chat GPT"
    },
    "deepseek": {
        "khmer": "Deep Seek",
        "english": "Deep Seek"
    },
    "google": {
        "khmer": "អ្នកបកប្រែ",
        "english": "Translator"
    },
    "gemini": {
        "khmer": "Gemini <span class='arial ml-1.5'>AI</span>",
        "english": "Gemini AI"
    },
    "meta": {
        "khmer": "Meta <span class='arial'>AI</span>",
        "english": "Meta AI"
    },
    "other": {
        "khmer": "Other <span class='arial'>AI</span>",
        "english": "Other AI"
    },
    "grok": {
        "khmer": "Grok <span class='arial'>AI</span>",
        "english": "Grok AI"
    },

    "select": {
        "khmer": "អ្នកអាចជ្រើសរើសពាក្យណាមួយឬសរសេរដើម្បីចែករំលែក",
        "english": "You can write or select any passage of text to share"
    },
    "select2": {
        "khmer": "ទំព័រនេះត្រូវបានចម្លងទៅកាន់ក្ដារតម្បៀតខ្ទង់របស់អ្នកហើយ!",
        "english": "This page has been copied to your clipboard!"
    },
    "select3": {
        "khmer": "ចែករំលែក",
        "english": "Share"
    },
    "select4": {
        "khmer": "ចម្លង",
        "english": "Copy"
    },
    "select8": {
        "khmer": "បិទភ្ជាប់",
        "english": "Paste"
    },
    "select5": {
        "khmer": "បោះបង់",
        "english": "Cancel"
    },
    "select6": {
        "khmer": "តើអ្នកចង់ចាប់ផ្ដើមម្ដងទៀតដែរឬទេ?",
        "english": "Would you like to start over?"
    },
    "select7": {
        "khmer": "តើអ្នកចង់ដាក់ពាក្យចម្លងនៅទីនេះឬទេ?",
        "english": "Would you like to paste?"
    },

    "typo": {
        "khmer": "កន្លែងផ្តល់យោបល់កែលំអការខ្វះខាត",
        "english": "Found a mistake?"
    },
    "typo2": {
        "khmer": "សូមសរសេរយោបល់របស់អ្នកនៅក្នុងប្រអប់ខាងក្រោម",
        "english": "How can we make this page better?"
    },

    "story": {
        "khmer": "ចុចទីនេះដើម្បីមើលការប្រជុំនេះនៅលើ YouTube",
        "english": "Tap here to watch this sermon on YouTube"
    },
    "buddha2": {
        "khmer": "ចិត្តគឺជាទាំងអស់។ អ្វីដែលអ្នកគិត អ្នកនឹងក្លាយទៅជាវា។ ចិញ្ចឹមចិត្តរបស់អ្នកដោយការរៀនសូត្រ និងការយល់ដឹង។",
        "english": "The mind is everything. What you think you become. Cultivate your mind through learning and understanding."
    }
}
